import * as Yup from "yup";

export const initialValues = {
  relationToCompany: "",
  file: "",
};

export const validationSchema = Yup.object({
  relationToCompany: Yup.string().required("Required Field"),
  file: Yup.mixed()
    .required("Required Field")
    .test("type", "Invalid file type. Supported file type is Pdf, Docx", (value) => {
      return value && value?.type === "application/pdf";
    }),
});
